const DEFAULT_LANGUAGE = "ru";

const SUPPORTED_LANGUAGES = {
  "en": {
    "url": "/en",
    "regex": "\\/en\\b",
    "description": "English"
  },
  "ua": {
    "url": "/ua",
    "regex": "\\/ua\\b",
    "description": "Українська"
  },
  "ru": {
    "url": "",
    "regex": "\\/$|\\b",
    "description": "Русский"
  }
};

const HELMET_HTML_BY_LANG = {
  "en": "en-US",
  "ua": "uk-UA",
  "ru": "ru-RU"
};

const regex = {
  AMOUNT: "^\\d+(\\.\\d{1,8})?$",
  DECIMAL_AMOUNT: /^(\d{0,10})(\.\d{0,8})?$/g,
  FLOAT_VALUE_WRITE: /\D*(\d+\.?\d{0,8})?.*/g,
  ONE_ELEMENT: "$1",
  CALCULATED_AMOUNT: /^(\d{0,10})(\.\d{0,8})?$/g,
  FLOAT_NUMBER: /^(\d{0,10})(\.\d+)?$/g,
  CYRILLIC_SYMBOLS: /[а-яА-ЯЁёҐґІіЇїЄє]/u,
  IP_V4_ADDRESSES: /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/,
  IP_V6_ADDRESSES: /^(?:(?:[0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|(?!(?:.*[0-9a-fA-F]:){8,})(?:(?:[0-9a-fA-F]{1,4}:){0,6}[0-9a-fA-F]{1,4}?(?::[0-9a-fA-F]{1,4}){0,1}?)?::(?:[0-9a-fA-F]{1,4}:){0,6}[0-9a-fA-F]{1,4}?(?::[0-9a-fA-F]{1,4}){0,1}?)$/
};

const MS_CASH = "MsCash";
const OCT7 = "OCT7";

const BALANCE_NOTIFICATION_ACTION_URL = {
  user: "/api/balances/user/telegram-notification/",
  admin: "/api/balances/telegram-notification/"
};

const PAYMENT_SYSTEM = {
  BALANCE_REFILING: "BALANCE_REFILING",
  BALANCE_TRANSFER: "BALANCE_TRANSFER"
};

const TRANSFER_STATUSES = {
  NEW: "NEW",
  PENDING: "PENDING",
  PROCESSED: "PROCESSED",
  FAIL: "FAIL"
};

const DIRECTIONS = {
  PAYMENT: "payment",
  PAYOUT: "payout"
};

const TRANSFER_USER = {
  SENDER: "sender",
  RECEIVER: "receiver"
};

const ROLES = {
  ROLE_USER: "ROLE_USER",
  ROLE_ADMIN: "ROLE_ADMIN",
  ROLE_SUPER_ADMIN: "ROLE_SUPER_ADMIN",
  ROLE_PROJECT: "ROLE_PROJECT",
  ROLE_SUPPORT: "ROLE_SUPPORT",
  ROLE_MASTER: "ROLE_MASTER"
};

const HTTP_STATUSES = {
  HTTP_OK: 200,
  HTTP_CREATED: 201,
  HTTP_NO_CONTENT: 204,
  HTTP_BAD_REQUEST: 400,
  HTTP_ERROR_VALIDATION: 422
};

const TOPICS_LIST = {
  DEFAULT_BADGES: "badges",
  TRANSFER: {
    UPDATE_EVENT_TOPIC: "http://localhost/api/transfers",
    RECEIVER_EVENT_TOPIC: "http://localhost/api/transfers/reciever/"
  },
  BATCHES: {
    UPDATE_EVENT_TOPIC: "http://localhost/api/batches"
  }
};

const ATTRIBUTES = {
  WALLET: "wallet",
  CARD_NUMBER: "cardNumber",
  STABLING_CURRENCY: "stablingCurrency",
  IS_STABLING: "isStabling"
};

const NULLABLE_ATTRIBUTES = ["stablingCurrency", "clientId", "walletClientId"];

const TRANSFER_DEFAULT_PROJECT_NAME = "Transfer";

const STANDARD_ERRORS_WAY = "error.response.data.data.errors";

const DEFAULT_ITEMS_PER_PAGE_VALUE = 30;

const EXCHANGE_TYPE = {
  IN: "in",
  OUT: "out"
};

const CURRENCY_TYPE = {
  CRYPTO: "CRYPTO",
  CURRENCY: "CURRENCY"
};

const STABLE_COIN = "USDT";

const EXCHANGE_VALIDATION_EXCLUDING_KEYS = ["connectionId"];

const PROJECT_SETTINGS = {
  TRUSTED_IP_ADDRESSES: "trustedIpAddress"
};

const PROJECT = {
  MAX_TRUSTED_IP_COUNT: 5
};

const decimalFixed = 16;
const decimalFixedMid = 10;
const decimalFixedShort = 8;

const stablingCurrencies = [
  { asset: "USDT", name: "default" },
  { asset: "EUR", name: "eur" }
];

const userAdminFieldsConsts = {
  DESCRIPTION: "description"
};

const exclusionNames = [
  "bin",
  "countryCode",
  "country",
  "bank",
  "paymentSystem"
];

const exclusionNamesNew = [
  "bin",
  "country"
];

const frontendSettings = {
  hideZeroBalances: "hideZeroBalances",
  hideZeroBalancesAdmin: "hideZeroBalancesAdmin",
  hideZeroClientBalancesAdmin: "hideZeroClientBalancesAdmin",
  hideZeroClientBalances: "hideZeroClientBalances",
  hideInactiveClient: "lastTransactionCreatedAt"
};

const activeFilter = {
  TRUE: "true",
  FALSE: "false"
};

const BOOLEAN_FLAGS = {
  TRUE: "1",
  FALSE: "0"
};

const EXCLUSION_SERVICES = [
  "PSP1"
];

const EXCLUSION_HIDDEN_FIELDS = [
  "firstName",
  "lastName",
  "email",
  "applicantId"
];

const EXCLUSION_PAYMENT_SYSTEMS = [
  "BALANCE_REFILING"
];

const EXCLUSION_TYPES = {
  blacklist: "blacklist",
  whitelist: "whitelist"
};

const SERVICES = {
  HRYVNIA8: "Hryvnia8",
  ALP_PAY: "AlpPay",
};

const FIAT_CURRENCIES = {
  UAH: "UAH"
};

const PAYMENT_TYPE = {
  manual: "manual",
  bath: "mass"
};

const TRANSACTION_TYPE_PAYMENT = {
  ORDER: "order",
  REFILLING: "refilling",
  TRANSFER: "transfer",
  INCOME: "income",
  RESERVE: "reserve"
};

const TRANSACTION_TYPE_PAYOUT = {
  ORDER: "order",
  REFILLING: "refilling",
  TRANSFER: "transfer",
  REFUND: "refund",
  EXPENSE: "expense"
};

const TRANSACTION_TYPES = {
  ORDER: "order",
  REFILLING: "refilling",
  REFUND: "refund",
  EXPENSE: "expense",
  INCOME: "income"
};

const RESERVED_BALANCE_TRANSACTION_TYPES = {
  RESERVE: "reserve",
  PAYMENT: "payment"
};

const FAIL_TRANSACTION_ALLOWED_EMAILS = [
  "58l306a3osaogns4@itlab-studio.com",
  "dkdev@itlab-studio.com",
  "misha.shyrman@itlab-studio.com",
];

const RETRIGGER_ALP_PAYOUT_ALLOWED_EMAILS = [
  "58l306a3osaogns4@itlab-studio.com",
  "dkdev@itlab-studio.com",
];

const RETRIGGER_TELEGRAM_DRAIN_ALLOWED_EMAILS = [
  "58l306a3osaogns4@itlab-studio.com",
  "dkdev@itlab-studio.com",
];

const PAYMENT_TYPES = {
  API: "api",
  MANUAL: "manual",
  MASS: "mass"
};

const THEME_COLOR = {
  LIGHT: "light",
  DARK: "dark"
};

export {
  DEFAULT_LANGUAGE,
  SUPPORTED_LANGUAGES,
  HELMET_HTML_BY_LANG,
  MS_CASH,
  OCT7,
  TRANSFER_DEFAULT_PROJECT_NAME,
  BALANCE_NOTIFICATION_ACTION_URL,
  ROLES,
  PAYMENT_SYSTEM,
  TRANSFER_STATUSES,
  DIRECTIONS,
  HTTP_STATUSES,
  TOPICS_LIST,
  TRANSFER_USER,
  ATTRIBUTES,
  STANDARD_ERRORS_WAY,
  DEFAULT_ITEMS_PER_PAGE_VALUE,
  EXCHANGE_TYPE,
  CURRENCY_TYPE,
  STABLE_COIN,
  PROJECT_SETTINGS,
  PROJECT,
  EXCHANGE_VALIDATION_EXCLUDING_KEYS,
  regex,
  decimalFixed,
  decimalFixedMid,
  decimalFixedShort,
  stablingCurrencies,
  userAdminFieldsConsts,
  exclusionNames,
  exclusionNamesNew,
  frontendSettings,
  activeFilter,
  NULLABLE_ATTRIBUTES,
  BOOLEAN_FLAGS,
  EXCLUSION_SERVICES,
  EXCLUSION_HIDDEN_FIELDS,
  EXCLUSION_PAYMENT_SYSTEMS,
  EXCLUSION_TYPES,
  SERVICES,
  FIAT_CURRENCIES,
  PAYMENT_TYPE,
  TRANSACTION_TYPE_PAYMENT,
  TRANSACTION_TYPE_PAYOUT,
  TRANSACTION_TYPES,
  RESERVED_BALANCE_TRANSACTION_TYPES,
  PAYMENT_TYPES,
  THEME_COLOR,
  FAIL_TRANSACTION_ALLOWED_EMAILS,
  RETRIGGER_ALP_PAYOUT_ALLOWED_EMAILS,
  RETRIGGER_TELEGRAM_DRAIN_ALLOWED_EMAILS
};